import React from 'react';
import { FaWindowClose, FaArrowCircleRight, FaSuitcase } from 'react-icons/fa';
import Slider from 'react-slick';
import { peerlessData } from './PeerlessData';


const Services = ({setNavLinks, handleServiceLinks, isWindowReduced, slidesToShow0, setSlidesToShow0, sliderState, setSliderState, handleAfterChange}) => {



  React.useEffect(() => {

    // retrieve slider state from local storage on component mount
    const storedState = JSON.parse(sessionStorage.getItem('sliderState'));
    if(storedState){setSliderState(storedState)} 

    const handleResize = () => {
      if (window.innerWidth >= 1030) {
        setSlidesToShow0(5);
      } else if (window.innerWidth >= 600) {
        setSlidesToShow0(4);
      } else if (window.innerWidth >= 300) {
        setSlidesToShow0(2);
      } else {
        setSlidesToShow0(1);
      }

      
    };

    handleResize()
    window.addEventListener('resize', handleResize);
    
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [setSlidesToShow0, setSliderState]);

  

    const settings = {

        dots: false,
        infinity: true,
        slidesToShow: slidesToShow0,
        slidesToScroll: 1,
        lazyLoad: true,
        Speed: 200,
        swipe: true,
        swipeToSlide: true,
    }



  return (
    <div  className='container-fluid '>

        
                <div className='close-window-icon' ><FaWindowClose color='#1b2328' onClick={()=>{
                  setNavLinks({homeLink: true})
                  sessionStorage.setItem("currentSession", JSON.stringify({homeLink: true}));
                  }}/> </div>
                <h1 className='title'><FaSuitcase color='#1b2328' /> Our Services</h1>


                <div className=' imgslider'>

                    <Slider {...settings} afterChange={handleAfterChange} initialSlide={sliderState.currentSlide}>
                                    
                        {
                            peerlessData.map( (data) =>{
                            
                            
                            return (

                                <article className='service-card' key={data.id}>
                                    
                                        <div className='img-wrapper'>

                                            <img src={require(`../Images/ServiceImages/${data.image}`)} alt=""/>
                                        </div>

                                        <div className='service-details'>

                                            <h3>{data.serviceName}</h3>
                                            <button onClick={()=>{
                                            
                                                    handleServiceLinks(data.id)
                                                    
                                            
                                            }}> View <FaArrowCircleRight color='#fff'/></button>
                                        </div>
                                    
                                </article>
                            
                                )
                            }) 
                        }
                    </Slider>
                </div>

                {isWindowReduced && <p className='d-flex justify-content-center custom-info'> Slide to see more </p>}


               
    

    </div>
  )
}

export default Services;